import axios from './axios_interceptors'
import config from '@/services/config'
import { tokenExpired } from '@/auth/utils'

export default {
  createChatBrandmeTalent(data) {
    return axios.post(`${config.urlCore}/api/v3/chat/create/brandme-talent/`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      });
  },
  priceRequest(chat_uuid, reason) {
    return axios.post(`${config.urlCore}/api/v3/chat/message/price-request/${chat_uuid}/`,
      {reason},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      });
  },
  getChats(data, page, size_page) {
    return axios.post(`${config.urlCore}/api/v3/chat/?page=${page}&size_page=${size_page}`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  getChatsV4(data, page, size_page) {
    return axios.post(`${config.urlCore}/api/v4/chats/?page=${page}&size_page=${size_page}`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  getChatsNew(id) {
    return axios.post(`${config.urlCore}/api/v4/chats/start/`,
      { user_id: id },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  getDetailChatV4(chat_uuid) {
    return axios.get(`${config.urlCore}/api/v4/chats/${chat_uuid}/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  getDetailChat(chat_uuid) {
    return axios.get(`${config.urlCore}/api/v3/chat/${chat_uuid}/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  sendMessageText(chat_uuid, message) {
    return axios.post(`${config.urlCore}/api/v3/chat/send/message/${chat_uuid}/`,
      {message},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return { error: true, ...error.response.data.response }
      })
  },
  sendMessageTextV4(chat_uuid, message, chat_deal_uuid = null) {
    const payload = { message };

    if (chat_deal_uuid) {
      payload.chat_deal_uuid = chat_deal_uuid;
    }

    return axios.post(`${config.urlCore}/api/v4/chats/send-message/${chat_uuid}/`,
      payload,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return { error: true, ...error.response.data.response }
      })
  },
  archiveChatV4(chat_uuid) {
    return axios.post(`${config.urlCore}/api/v4/chats/archive/${chat_uuid}/`,
      {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return { error: true, ...error.response.data.response }
      })
  },
  unarchiveChatV4(chat_uuid) {
    return axios.post(`${config.urlCore}/api/v4/chats/unarchive/${chat_uuid}/`,
      {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return { error: true, ...error.response.data.response }
      })
  },
  markAsReaded(chat_uuid) {
    return axios.get(`${config.urlCore}/api/v3/chat/mark/seen/${chat_uuid}/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  markAsReadedV4(chat_uuid) {
    return axios.get(`${config.urlCore}/api/v4/chats/mark/seen/${chat_uuid}/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  uploadFilesInChat(chat_uuid, data) {
    return axios.post(`${config.urlCore}/api/v3/chat/send/file/${chat_uuid}/`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return { error: true, ...error.response.data.response }
      })
  },
  uploadFilesInChatV4(chat_uuid, data) {
    return axios.post(`${config.urlCore}/api/v4/chats/send/file/${chat_uuid}/`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return { error: true, ...error.response.data.response }
      })
  },
  uploadLinksInChat(chat_uuid, data) {
    return axios.post(`${config.urlCore}/api/v3/chat/send-links/${chat_uuid}/`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  uploadLinksInChatV4(chat_deal_uuid, data) {
    return axios.post(`${config.urlCore}/api/v4/chats/send-links/${chat_deal_uuid}/`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  acceptChat(user_proposal_uuid) {
    return axios.get(`${config.urlCore}/api/v3/proposals/accept/${user_proposal_uuid}/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  declineChat(user_proposal_uuid, reason) {
    return axios.post(`${config.urlCore}/api/v3/proposals/reject/${user_proposal_uuid}/`,
      {reason},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  uploadContentsChat(chat_uud, data) {
    return axios.post(`${config.urlCore}/api/v3/chat/upload-contents/${chat_uud}/`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      })
  },
  uploadContentsChatV4(chat_uud, data) {
    return axios.post(`${config.urlCore}/api/v4/chats/upload-contents/${chat_uud}/`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      })
  },
  requestRevisionChat(chat_uud, message, revision_url) {
    return axios.post(`${config.urlCore}/api/v3/chat/${revision_url}/${chat_uud}/`,
      {message},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      })
  },
  requestRevisionChatV4(chat_uuid, message) {
    return axios.post(`${config.urlCore}/api/v4/chats/request-revision/${chat_uuid}/`,
      {message},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      })
  },
  requestRevisionLinksChatV4(chat_uuid, message) {
    return axios.post(`${config.urlCore}/api/v4/chats/request-revision-links/${chat_uuid}/`,
      {message},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      })
  },
  acceptContents(chat_uud, accept_url) {
    return axios.get(`${config.urlCore}/api/v3/chat/${accept_url}/${chat_uud}/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  acceptContentsV4(chat_uud) {
    return axios.get(`${config.urlCore}/api/v4/chats/accept-contents/${chat_uud}/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  acceptLinksV4(chat_uud) {
    return axios.get(`${config.urlCore}/api/v4/chats/accept-links/${chat_uud}/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  getUnreadChats() {
    return axios.get(`${config.urlCore}/api/v3/chat/count-unread-chats/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      })
  },
  getCheckoutPitch(pitch_uuid)  {
    return axios.get(`${config.urlCore}/api/v3/casting-calls/checkout-pitch/${pitch_uuid}/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      })
  },
  getAssetContentUrl(message_uuid) {
    return axios.get(`${config.urlCore}/api/v3/chat/get-asset-content/${message_uuid}/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      });

  },
  getAssetContentUrlV4(message_uuid) {
    return axios.get(`${config.urlCore}/api/v4/chats/get-asset-contents/${message_uuid}/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      });

  }
}